var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.272 17.0574C26.272 11.9049 22.1205 7.72798 16.9993 7.72798C11.8781 7.72798 7.72656 11.9049 7.72656 17.0574C7.72656 21.7139 11.1175 25.5735 15.5504 26.2734V19.7542H13.196V17.0574H15.5504V15.002C15.5504 12.6638 16.9348 11.3723 19.0529 11.3723C20.0674 11.3723 21.1286 11.5545 21.1286 11.5545V13.8504H19.9593C18.8074 13.8504 18.4482 14.5695 18.4482 15.3073V17.0574H21.0199L20.6088 19.7542H18.4482V26.2734C22.8811 25.5735 26.272 21.7139 26.272 17.0574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.7673cf23e9b0780e9474230f2137f69c.svg";
export { ForwardRef as ReactComponent };